module.exports = __webpack_public_path__ + "assets/img/es-92e38163.png";